import * as React from "react";
import Helmet from "react-helmet";
import { t } from "@lingui/macro";
import { I18n } from "@lingui/react";

import Forgot from "../../components/Auth/AuthForm/ForgotPassword";

export const ForgotScene = () => (
  <I18n>
    {({ i18n }) => (
      <div className="Wrapper-inner">
        <Helmet
          title={i18n._(t("forgot_password.form_title")`Forgot Password`)}
        />
        <Forgot />
      </div>
    )}
  </I18n>
);
